import { useDispatch, useSelector } from '@redux';
import { getAddress } from '@redux/config/actions';
import { Col, Form } from 'antd';
import { useEffect, useState } from 'react';
import SelectCustom from './SelectCustom';
import { DynamicObjectType } from 'types/commons';
import { useRestContext } from 'components/form/RestInputContext';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

export default function VNCitySelector({
  rootSource,
  disabled,
  required,
}: {
  rootSource: string;
  disabled?: DynamicObjectType;
  required?: boolean;
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { form } = useRestContext();
  const cities = useSelector(
    (state) => state.config.address,
  ) as DynamicObjectType[];

  const provinceSource = `${rootSource ? `${rootSource}.` : ''}provinceId`;

  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);

  const selectCity = (e) => {
    const selectedCity = cities?.find((city) => city.id === e);
    setDistricts(selectedCity?.districts);
    form.setFieldsValue({
      [`${rootSource ? `${rootSource}.` : ''}districtId`]: null,
      [`${rootSource ? `${rootSource}.` : ''}wardId`]: null,
    });
    return e;
  };

  const selectDistrict = (e) => {
    setWards(districts?.find((district) => district.id === e)?.wards);
    form.setFieldsValue({
      [`${rootSource ? `${rootSource}.` : ''}wardId`]: null,
    });
    return e;
  };

  useEffect(() => {
    dispatch(getAddress());
  }, []);

  useEffect(() => {
    const selectedCity = cities?.find(
      (city) => city.id === get(form.getFieldsValue(), provinceSource),
    );
    setDistricts(selectedCity?.districts);
    setWards(
      selectedCity?.districts?.find(
        (district) =>
          district.id ===
          get(
            form.getFieldsValue(),
            `${rootSource ? `${rootSource}.` : ''}districtId`,
          ),
      )?.wards,
    );
  }, [cities]);

  return (
    <>
      <Col md={12} sm={24} xs={24}>
        <SelectCustom
          disabled={disabled?.province}
          source={provinceSource}
          resourceData={cities}
          titleProp="name"
          valueProp="id"
          formOptions={{ getValueFromEvent: selectCity }}
          header={t('mores.locations.address.city.label')}
          placeholder={t('mores.locations.address.city.placeholder')}
          required={required}
          allowClear
        />
      </Col>
      <Col md={12} sm={24} xs={24}>
        <SelectCustom
          disabled={disabled?.district}
          source={`${rootSource ? `${rootSource}.` : ''}districtId`}
          resourceData={districts}
          titleProp="name"
          valueProp="id"
          required={required}
          header={t('mores.locations.address.district.label')}
          formOptions={{ getValueFromEvent: selectDistrict }}
          placeholder={t('mores.locations.address.district.placeholder')}
          allowClear
        />
      </Col>
      <Col md={12} sm={24} xs={24}>
        <SelectCustom
          disabled={disabled?.ward}
          source={`${rootSource ? `${rootSource}.` : ''}wardId`}
          resourceData={wards}
          titleProp="name"
          valueProp="id"
          header={t('mores.locations.address.ward.label')}
          placeholder={t('mores.locations.address.ward.placeholder')}
          required={required}
          allowClear
        />
      </Col>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, curValues) => {
          const selectedCity = cities?.find(
            (city) => city.id === get(curValues, provinceSource),
          );
          if (
            !districts?.length &&
            get(curValues, provinceSource) &&
            selectedCity?.districts
          ) {
            setDistricts(selectedCity?.districts);
          }
          if (
            get(prevValues, provinceSource) !==
              get(curValues, provinceSource) &&
            selectedCity?.districts
          ) {
            setDistricts(selectedCity?.districts);
          }
          if (
            !wards?.length &&
            get(curValues, `${rootSource ? `${rootSource}.` : ''}districtId`) &&
            selectedCity?.districts
          ) {
            setWards(
              selectedCity?.districts?.find(
                (district) =>
                  district.id ===
                  get(
                    curValues,
                    `${rootSource ? `${rootSource}.` : ''}districtId`,
                  ),
              )?.wards,
            );
          }
          if (
            get(
              prevValues,
              `${rootSource ? `${rootSource}.` : ''}districtId`,
            ) !==
              get(
                curValues,
                `${rootSource ? `${rootSource}.` : ''}districtId`,
              ) &&
            selectedCity?.districts
          ) {
            setWards(
              selectedCity?.districts?.find(
                (district) =>
                  district.id ===
                  get(
                    curValues,
                    `${rootSource ? `${rootSource}.` : ''}districtId`,
                  ),
              )?.wards,
            );
          }
          return true;
        }}
      >
        {() => null}
      </Form.Item>
    </>
  );
}
